import React, { useState } from 'react'
import confirm from 'components/dialogConfirm'
import FbButton from 'components/FbUI/FbButton'

export function DialogConfirmMock(): React.ReactElement {
  const [result, setResult] = useState<string | null>(null)

  const handleClick = async () => {
    const confirmed = await confirm(
      'Are you sure you want to delete this item? This action cannot be undone.',
      'Delete Item',
      '',
      { confirmLabel: 'Delete', buttonVariant: 'danger' }
    )
    setResult(confirmed ? 'Confirmed' : 'Cancelled')
  }

  return (
    <div className="flex flex-col gap-3">
      <FbButton variant="danger" onClick={handleClick}>
        Delete Item
      </FbButton>
      {result && (
        <p className="text-sm text-fg-secondary">
          Result: <strong>{result}</strong>
        </p>
      )}
    </div>
  )
}
